function u(t) {
  return function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = n.width ? String(n.width) : t.defaultWidth, e = t.formats[r] || t.formats[t.defaultWidth];
    return e;
  };
}
export {
  u as default
};
